import { APP_SETTINGS } from "../../config";
import axios from "axios";

export function getStudentPaymentDetails() {
  return axios.get(APP_SETTINGS.API_PATH.STUDENT_PAYMENT.getStudentPaymentDetails, {
  });
}